/** Max study time credited per completion — mirrors backend StudyTime.MAX_MINUTES_PER_EVENT. */
export const MAX_STUDY_DURATION_MS = 60 * 60 * 1000

/**
 * Active study duration: accumulated visible time + current visible segment.
 * Idle gaps (tab hidden / session restore) must already be excluded from the inputs.
 */
export function studyDurationMs(
  activeStudyMs: number,
  segmentStartedAt: number,
  options?: { now?: number; paused?: boolean },
): number {
  const now = options?.now ?? Date.now()
  const live = options?.paused ? 0 : Math.max(0, now - segmentStartedAt)
  return Math.min(MAX_STUDY_DURATION_MS, Math.max(0, activeStudyMs + live))
}

export function studyDurationMinutes(
  activeStudyMs: number,
  segmentStartedAt: number,
  options?: { now?: number; paused?: boolean },
): number {
  const ms = studyDurationMs(activeStudyMs, segmentStartedAt, options)
  if (ms <= 0) return 0
  return Math.min(60, Math.max(1, Math.round(ms / 60_000)))
}
